module.exports = __webpack_public_path__ + "img/FlyZermatt-logo-light.64d6868e.svg";